export default __webpack_public_path__ + "static/media/menu7_hl.07a90030.png";